module.exports = __webpack_public_path__ + "img/step3.92a1a516.png";